// extracted by css-extract-rspack-plugin
export default {"editor":"CodeMirrorEditor-module__editor___eAEq9"};